import hatsApi from '@/services/hatsApi'

export default {
  getPeriods (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/transport-time-period/?filter=' + JSON.stringify(filter))
  },
  getTimes (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/transport-time/?filter=' + JSON.stringify(filter))
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Transport.js